export enum ProjectionCodesEnum {
  RD = 'EPSG:28992',
  WGS84 = 'WGS84',
}
